<!-- Region Setting -->
<div class="content" style="margin-bottom: 0px;">
  <div class="container-fluid">
    <div class="page-title license-title">
      <h1>
        <a href="javascript:void(0);" (click)="goBack()" class="back" *ngIf="IsSuperAdmin">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        Company management
        <small *ngIf="!powerMaster">
          <a [routerLink]="'/help/pro'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
      <div *ngIf="!IsRegionAdmin">
        <button pButton type="button" *ngIf="!IsInternalAdmin" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showDialog()"></button>
        <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedRegion == null" class="{{Confirm_button}} update" (click)="showEditDialog()"></button>
        <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}} update" [disabled]="selectedRegion == null" (click)="showDeleteRegion()"></button>
        <!-- <button pButton type="button" *ngIf="IsSuperAdmin" [disabled]="selectedRegion == null" label="Edit Member" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showAddCompanyMemberDialog(selectedRegion.data.Region, selectedRegion.data.Id, selectedRegion.data.ParentRegionId)"></button> -->
        <button pButton type="button" *ngIf="IsSuperAdmin" [disabled]="selectedRegion == null" label="Authority" icon="fa fa-unlock-alt" class="{{Confirm_button}}" (click)="showAddAuthority(selectedRegion.HashObj)"></button>
      </div>
      <!-- <div *ngIf="!IsSuperAdmin && !powerMaster && IsLocalAdminMsp">
        <button pButton type="button" label="Member" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showAddCompanyMemberDialog(regionName, regionId, parentRegionId)"></button>
        <button pButton type="button" label="Authority" icon="fa fa-unlock-alt" class="{{Confirm_button}}" (click)="showAddAuthority(regionName, regionId, parentRegionId)"></button>
      </div> -->
    </div>
    <!-- <div *ngIf="IsSuperAdmin" class="page-filter clearfix" style="margin: 0"> -->
    <!-- <div class="page-filter clearfix" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Company Management</h5>
        <div *ngIf="!IsRegionAdmin">
          <button pButton type="button" *ngIf="!IsInternalAdmin" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showDialog()"></button>
          <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedRegion == null" class="{{Confirm_button}} update" (click)="showEditDialog()"></button>
          <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}} update" [disabled]="selectedRegion == null" (click)="showDeleteRegion()"></button>
          <button pButton type="button" *ngIf="IsSuperAdmin" [disabled]="selectedRegion == null" label="Edit Member" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showAddCompanyMemberDialog(selectedRegion.Region, selectedRegion.Id, selectedRegion.ParentRegionId)"></button>
          <button pButton type="button" *ngIf="IsSuperAdmin" [disabled]="selectedRegion == null" label="Authority" icon="fa fa-unlock-alt" class="{{Confirm_button}}" (click)="showAddAuthority(selectedRegion.HashObj)"></button>
        </div>
      </div>
    </div> -->
    <div class="page-content border-b-radius-none" style="margin: 0">
      <p-treeTable [value]="treeRegion" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20]" [columns]="regionTable_cols" selectionMode="single" [(selection)]="selectedRegion">
        <ng-template pTemplate="header" let-columns>
          <!-- <tr>
            <th *ngFor="let col of columns" [ttSortableColumn]="col.field">
              {{col.header | translate}}
              <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
            </th>
          </tr> -->
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.visible" [ttSortableColumn]="col.sortIcon ? col.field : null" [ngStyle]="{'width.px': (col.width)}" [ngClass]="col.class">
                {{col.header}}
                <p-treeTableSortIcon [field]="col.field" *ngIf="col.sortIcon"></p-treeTableSortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr [ttSelectableRow]="rowNode">
            <td style="width: 250px;" class="col-nowrap ellipsis" title="{{rowData.RegionName}}">
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              {{rowData.RegionName}}
            </td>
            <td class="col-normal" style="width: 240px; overflow: hidden;">
              {{rowData.account}}
            </td>
            <td class="col-normal" style="width: 240px; overflow: hidden;">
              {{rowData.device_managers}}
            </td>
            <td class="col-normal" style="width: 240px; overflow: hidden;">
              {{rowData.viewers}}
            </td>
            <td class="col-nowrap" style="width: 170px" *ngIf="IsSuperAdmin">
              <span>{{rowData.MspPlanName}}</span>
            </td>
            <td class="col-nowrap" style="width: 170px">
              <span>{{rowData.DeviceUsage ? rowData.DeviceUsage : 0}}</span>
              <button type="button" class="btn btn-outline-dark btn-sm" (click)="showUsedDeviceHistory(rowData.HashObj);" style="float: right;">
              <span class="fa fa-history"></span> History</button>
            </td>
            <td class="col-nowrap default" style="width: 90px" *ngIf="IsSuperAdmin">
              <button type="button" class="btn btn-outline-dark btn-sm" (click)="showSmartPowerReport(rowData.Id);">Report</button>
            </td>
            <!-- 2025-07-31 kyrie 手動Activate MSP功能移除 -->
            <!-- <td class="col-right col-nowrap" style="width: 120px" *ngIf="!powerMaster && IsSuperAdmin">
              <a class="btn btn-secondary btn-sm detail" (click)="showActivateCompanyPlanConfirmDialog(rowData)" *ngIf="rowData.IsMsp && !rowData.MspActivate && rowData.ParentRegionId === -1 && !IsLocalAdminMsp" ngClass="">Activate</a>
              <a class="btn btn-secondary btn-sm detail" *ngIf="rowData.MspActivate && rowData.ParentRegionId === -1 && !IsLocalAdminMsp" [ngClass]="{'disabled': rowData.MspActivate }">Activated</a>
              <a class="btn btn-secondary btn-sm detail" (click)="showActivateCompanyPlanConfirmDialog(rowData)" *ngIf="!rowData.MspActivate && rowData.Id == rowData.MspMainRegionId" ngClass="">Activate</a>
              <a class="btn btn-secondary btn-sm detail" *ngIf="rowData.MspActivate  && rowData.Id == rowData.MspMainRegionId" [ngClass]="{'disabled': rowData.MspActivate }">Activated</a>
            </td> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td translate [attr.colspan]="getVisibleColumnsCount()">No Data found</td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </div>
</div>
<div class="content tree-organization total" style="margin-top: 0px;">
  <div class="container-fluid">
    <div class="page-filter clearfix" style="margin: 0; border-top: 1px solid #dddddd;">
      <div class="page-title sub-title border-b-radius-none" style="align-items: center; justify-content: flex-end;">
        <h5 class="float-left" style="font-size: 15px; font-weight: bolder;">Total Device Usage: {{totalDeviceUsage}}</h5>
        <div style="padding-left: 8px">
          <button pButton type="button" icon="pi pi-angle-right" class="{{Confirm_button}} update" (click)="showUsedDeviceDetail();"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Company Hierarchy  -->
<!-- 1.System Admin:    完全無限制角色	Company Hierarchy 看的到, 也可編輯  -->
<!-- 2.Region Admin:    該地區的Admin	Company Hierarchy 看的到, 不可編輯  -->
<!-- 3.Msp Admin:       母公司 Admin	Company Hierarchy 看的到, 也可編輯  -->
<!-- 4.Internal Admin:	子公司 Admin	Company Hierarchy 完全看不到  -->
<div *ngIf="!IsInternalAdmin" class="content tree-organization">
  <div class="container-fluid">
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0;border-bottom: 1px solid #ddd;">
      <div class="page-title sub-title">
        <h5 class="float-left">Company Hierarchy</h5>
        <div class="flex localAdmin" *ngIf="!IsRegionAdmin">
          <div class="flex localAdmin">
            <button pButton type="button" [disabled]="(selectedFile == null)" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showHierarchyDialog()"></button>
            <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}} update" (click)="showDeleteHierarchyDialog()" [disabled]="(selectedFile == null || selectedFile.children.length> 0 || selectedFile.Id == 1 || selectedFile.Id == selectedFile.MspMainRegionId)"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <p-tree class="hierarchyTree horizontal-tree member" [value]="hierarchyDataTree" selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="onNodeSelect($event)">
        <ng-template let-node pTemplate="default">
          <div class="hierarchy-content">
            <h5 class="hierarchy-name">{{ node.label }} ({{node.deviceUsage}})</h5>
            <div>
              <div *ngFor="let admin of node.adminsItem.slice(0, 3)" class="hierarchy-list">
                <i class="fa fa-user-circle" aria-hidden="true"></i>
                {{ admin }}
              </div>
              <p-accordion *ngIf="node.adminsItem.length > 3" (click)="toggleShowAll(node)">
                <p-accordion header="View {{ node.showAllAdmins ? 'Less' : 'More' }}">
                  <div *ngFor="let admin of node.adminsItem.slice(3)" class="hierarchy-list">
                    <i class="fa fa-user-circle" aria-hidden="true"></i>
                    {{ admin }}
                  </div>
                </p-accordion>
              </p-accordion>
            </div>
          </div>
        </ng-template>
      </p-tree>
    </div>
  </div>
</div>
<div class="content" style="margin: 60px 1.5em 30px 1.5em;" *ngIf="!this.powerMaster && (!this.IsSuperAdmin && !this.IsRegionAdmin) && (PROType === PROTypeIndex.Distributor)">
  <div class="container-fluid">
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Customer Management</h5>
        <div class="flex localAdmin">
          <div class="flex localAdmin" *ngIf="(!this.IsSuperAdmin && !this.IsRegionAdmin) && PROType === PROTypeIndex.Distributor">
            <button pButton type="button" label="Transfer NPM" icon="fa fa-exchange" class="{{Confirm_button}} update" (click)="showTransferNPMDialog();"
            [disabled]="checkTransferButton()"></button>
            <button pButton type="button" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showAddCustomerDialog()"></button>
            <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" class="{{Confirm_button}} update" (click)="showEditCustomerDialog()"
            [disabled]="(selectedCustomer == null)"></button>
            <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}}" [disabled]="(selectedCustomer == null)" [disabled]="(selectedCustomer == null)"
            (click)="checkDeleteCustomerDialog()"></button>
          </div>
          <!-- <div class="flex localAdmin" *ngIf="!isMsp">
            <button pButton type="button" label="Pay by Credit Card" icon="fa pi-credit-card" class="{{Confirm_button}} update" (click)="showTransferNPMDialog();"></button>
          </div> -->
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable hasSendMail" [columns]="customer_cols" [value]="customer" [(selection)]="selectedCustomer" selectionMode="single"
               [paginator]="true" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.visible" [pSortableColumn]="col.field" [ngStyle]="{'width.px': (col.width)}" [ngClass]="col.class">
                {{col.header}}
                <p-sortIcon *ngIf="col.sortIcon" [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td style="width:50px" class="col-nowrap">
              <span>{{i+1}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.RegionName}}</span>
            </td>
            <td class="col-normal" style="width: 240px; overflow: hidden;">
              {{rowData.Account}}
            </td>
            <td class="col-nowrap" style="width: 180px">
              <!-- <span *ngIf="rowData.MspDeviceLimit > 0">{{rowData.MspActivatedDevice ? rowData.MspActivatedDevice : 0}}/</span>{{rowData.MspDeviceLimit}} -->
              <span>{{rowData.UsedDevice ? rowData.UsedDevice : 0}}</span>
              <!-- <button type="button" class="btn btn-outline-dark btn-sm" (click)="showUsedDeviceHistory(rowData.HashObj);" style="float: right;">
              <span class="fa fa-history"></span> History</button> -->
            </td>
            <td style="width:180px" class="col-nowrap">
              <div class="flex align">
                <span>{{rowData.NpmBank}}</span>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of one month." *ngIf="(rowData.PROStatus !== PROStatusIndex.Created && rowData.PROStatus !== PROStatusIndex.Waiting) && rowData.NpmBankWarning && rowData.NpmBankWarningMonth === 1"></i>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of two months." *ngIf="(rowData.PROStatus !== PROStatusIndex.Created && rowData.PROStatus !== PROStatusIndex.Waiting) && rowData.NpmBankWarning && rowData.NpmBankWarningMonth === 2"></i>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of three months." *ngIf="(rowData.PROStatus !== PROStatusIndex.Created && rowData.PROStatus !== PROStatusIndex.Waiting) && rowData.NpmBankWarning && rowData.NpmBankWarningMonth === 3"></i>
                <i class="fa fa-exclamation-circle small" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="The NPM will be transferred only after the customer’s confirmation." *ngIf="(PROType === PROTypeIndex.Customer && PROPaymentSetting.PaymentRegionId === rowData.Id) && (rowData.PROStatus === PROStatusIndex.Created || rowData.PROStatus === PROStatusIndex.Waiting)"></i>
              </div>
            </td>
            <td style="width:240px" class="col-nowrap">
              <span>{{rowData.CreateTime}}</span>
            </td>
            <td class="col-nowrap" style="width: 150px;" [ngSwitch]="rowData.PROStatus">
              <div>
                <span *ngSwitchCase="0">Invitation Pending</span>
                <span *ngSwitchCase="1">Activated</span>
                <span *ngSwitchCase="2">Confirmation Awaiting</span>
                <span *ngSwitchCase="3">Locked</span>
              </div>
            </td>
            <td style="width:60px" class="send text-align-right">
              <button type="button" class="btn btn-outline-dark btn-sm mail" *ngIf="rowData.PROStatus === PROStatusIndex.Created || rowData.PROStatus === PROStatusIndex.Waiting" (click)="sendInvitation(rowData);"> <span class="pi pi-envelope"></span></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="customer_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="content" style="margin: 60px 1.5em 30px 1.5em;" *ngIf="!this.powerMaster && (PROType === PROTypeIndex.Distributor || (PROType === PROTypeIndex.Customer && PROPaymentSetting.PaymentRegionId === regionId) || (PROType === PROTypeIndex.PRO && IsProMainRegionAdmin))">
  <div class="container-fluid">
    <div class="page-filter clearfix two-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title" *ngIf="PROType === PROTypeIndex.Distributor">
            <div class="filter-content">
              <p-select [options]="CompanyOptions" [(ngModel)]="selectedCompany" (onChange)="AccountAcitvityFilter()"></p-select>
            </div>
          </div>
          <div class="filter-list">
            <div class="filter-content">
              <p-select [options]="yearOptions" [(ngModel)]="selectedYear" (onChange)="AccountAcitvityFilter()"></p-select>
            </div>
          </div>
          <div class="filter-list" *ngIf="PROType === PROTypeIndex.Customer">
            <div class="filter-content">
              <p-select [options]="monthOptions" [(ngModel)]="selectedMonth" (onChange)="AccountAcitvityFilter()"></p-select>
            </div>
          </div>
          <div class="filter-list">
            <div class="filter-content">
              <p-select [options]="actionTypeOptions" [(ngModel)]="selectedActionType" (onChange)="AccountAcitvityFilter()"></p-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Account Activity</h5>
        <div class="flex localAdmin">
          <div class="bank"><small>NPM Bank</small> <h5>{{ accountActivityNodeBank }}</h5> </div>
          <div class="flex localAdmin" *ngIf="(!this.IsSuperAdmin && !this.IsRegionAdmin) && PROPaymentSetting.UserChargeType !== null">
            <button pButton icon="fa fa-paypal" type="button" label="Pay by Credit Card" (click)="showPayByCardDialog();" class="p-button-primary"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table #AccountActivitydt class="deviceTable pageAllOptions" [paginator]="true" [rowsPerPageOptions]="[10,20]" [columns]="accountActivityTable_cols" [value]="accountActivityList" [paginator]="false" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
              <th *ngIf="i == 1" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
              <th *ngIf="i != 1" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.CreateTimeFormat}}</span>
            </td>
            <td style="width:220px" class="col-nowrap">
              <span>{{rowData.DisplayRegionName}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
                <span>{{rowData.ActionTypeStr}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span [ngClass]="{'positive': rowData.DisplayNodes> 0 ,'negative': rowData.DisplayNodes <0 }">{{rowData.DisplayNodes}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <div class="flex">
                <span>{{rowData.Balance}}</span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="accountActivityTable_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
        <!-- <ng-template pTemplate="footer">
          <tr>
            <td style="width:180px"></td>
            <td style="width:220px"></td>
            <td style="width:180px"></td>
            <td style="width:180px"><span>NPM Bank</span></td>
            <td style="width:180px"><span>{{accountActivityNodeBank}}</span></td>
          </tr>
        </ng-template> -->
      </p-table>
    </div>
  </div>
  <div class="container-fluid" *ngIf="!this.powerMaster && (PROType === PROTypeIndex.Distributor || (PROType === PROTypeIndex.Customer && PROPaymentSetting.PaymentRegionId === regionId) || PROType === PROTypeIndex.PRO)">
    <div class="page-filter clearfix border-b-radius-none" style="margin: 30px 0 0 0">
      <div class="page-title sub-title flex-start">
        <h5 class="float-left">Predicted NPM Usage</h5>
        <i class="fa fa-exclamation-circle small" tooltipPosition="bottom" tooltipStyleClass="available two-line" pTooltip="The minimum usage has been included in this section's calculation."></i>
      </div>
    </div>
    <div class="page-content border-t-radius-none" style="margin: 0">
      <p-table class="deviceTable pageAllOptions" [columns]="predictedNPMUsageTable_cols" [value]="predictedNPMUsageList"
        [paginator]="false" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
              <th [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.LastDeviceUsage}}</span>
            </td>
            <td style="width:250px" class="col-nowrap">
              <span>{{rowData.Growth}}</span>
            </td>
            <td style="width:300px" class="col-nowrap">
              <span>{{rowData.PredictedDeviceUsage}}</span>
            </td>
            <td style="width:200px" class="col-nowrap">
              <span>{{rowData.SettlementDate}}</span>
            </td>
            <td style="width:250px" class="col-nowrap">
              <div class="flex align">
                <span>{{rowData.PredictedBank}}</span>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of one month." *ngIf="rowData.PredictedBank < (rowData.PredictedDeviceUsage * 1)"></i>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of two months." *ngIf="rowData.PredictedBank < (rowData.PredictedDeviceUsage * 2) && rowData.PredictedBank >= (rowData.PredictedDeviceUsage * 1)"></i>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of three months." *ngIf="rowData.PredictedBank < (rowData.PredictedDeviceUsage * 3) && rowData.PredictedBank >= (rowData.PredictedDeviceUsage * 2)"></i>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="predictedNPMUsageTable_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Admin Settings -->
<p-dialog header="{{dialogInput.UpdateType}}" class="accountSetting" [(visible)]="adminSettingsDialog" [modal]="true" [style]="{'width': '450px', 'min-width': '230px'}" [baseZIndex]="10000"
          [blockScroll]="true" [ngClass]="{'inherit': inheritDialog }">
  <p-tabs class="settings_tabView" [ngClass]="{'hideHeader': dialogInput.UpdateType === 'Add Company' }" [tabindex]="selectDefaultTab" (valueChange)="onTabChange($event)" value="0">
    <p-tablist>
        <p-tab value="0">{{'Information' | translate}}</p-tab>
        <p-tab value="1">{{'SSO' | translate}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <ng-template pTemplate="header">{{'Information' | translate}}</ng-template>
        <div class="dialog-content">
          <div class="form-group">
            <label>Company Name <span class="alert-danger">*</span></label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.RegionName">
          </div>
          <!-- <div class="form-group" *ngIf="!!dialogInput.Id">
            <label>Domain <span class="alert-danger">*</span></label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.MspDomain">
          </div> -->
          <div class="form-group" *ngIf="!!dialogInput.Id">
            <label>Account Manager</label>
            <div class="select">
              <p-multiSelect [options]="adminsOptions" [(ngModel)]="dialogInput.Admins" [baseZIndex]="10000" [virtualScrollItemSize]="20" [selectedItemsLabel]="'{0} ' + ('company selected' | translate)" placeholder="{{'Choose' | translate}}" (onPanelShow)="onPanelShow();" (onPanelHide)="onPanelHide();">
                <ng-template let-item pTemplate="item" optionDisabled="disabled">
                  <span>{{item.label}}</span>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
          <!-- <div class="form-group" *ngIf="!!dialogInput.Id && showMainMSPAdminDropdownList">
            <label>Main MSP Admin <span class="alert-danger">* Cannot be changed after saving</span></label>
            <div class="select">
              <div class="select">
                <p-select [options]="MSPAdminOptions" [(ngModel)]="dialogInput.MSPAdmin" [disabled]="disableMainMSPAdminDropdown" placeholder="Select" [baseZIndex]="10000" appendTo="body"></p-select>
              </div>
            </div>
          </div> -->
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <ng-template pTemplate="header">{{' SSO ' | translate}}</ng-template>
        <div class="dialog-content">
          <div class="form-group" *ngIf="!!dialogInput.Id">
            <p-checkbox [binary]="true" [(ngModel)]="dialogInput.SSOEnable" (onChange)="selectedActiveSSO($event)"></p-checkbox> <span> Activate SSO</span>
          </div>
          <div class="form-group">
            <label>Identifier</label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.Identifier" [disabled]='true || !dialogInput.SSOEnable'>
          </div>
          <div class="form-group">
            <label>Reply Url</label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.ReplyUrl" [disabled]='true || !dialogInput.SSOEnable'>
          </div>
          <div class="form-group" *ngIf="!!dialogInput.Id">
            <label>Domain <span class="alert-danger">*</span></label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.MspDomain" [disabled]='!dialogInput.SSOEnable'>
          </div>
          <div class="form-group">
            <label>Login Url <span class="alert-danger">*</span></label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.LoginUrl" [disabled]='!dialogInput.SSOEnable'>
          </div>
          <div class="form-group file">
            <label>Upload Certification <small>(.cer)</small> <span class="alert-danger"> *</span></label>
            <div class="flex">
              <input type='file' name="Saml Certificate" #rootfile_upload accept="cer" class="form-control pInputText" (change)="handleFileInput($event)" [disabled]='!dialogInput.SSOEnable'>
              <a role="button" tabindex="0" class="btn btn-outline-primary btn-sm" [class.disabled]="!dialogInput.SSOEnable || (dialogInput.SSOEnable && (dialogInput.SAMLCertFile === null || dialogInput.SAMLCertFile === '')) ? true: null"
                (click)="downloadAzureBlobStorage(dialogInput.SAMLCertFile); $event.preventDefault()">
                <span class="pi pi-download"></span>
              </a>
            </div>
            <!-- 假如SAVE時檢查檔案錯誤顯示 -->
            <p-message severity="error" text="{{'File is not correct' | translate}}" *ngIf="false"></p-message>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template #footer>
    <button type="button" pButton (click)="saveSSO();" label="Save" class="{{Confirm_button}}" *ngIf="dialogInput.UpdateType === 'Add Company'"></button>
    <button type="button" pButton (click)="saveSSO();" label="Save" class="{{Confirm_button}}" *ngIf="dialogInput.UpdateType === 'Edit Company'" ></button>
    <button type="button" pButton (click)="adminSettingsDialog=false;" label="Cancel" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Delete Region Confirm -->
<p-dialog header="Confirm" [(visible)]="deleteRegionDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [baseZIndex]="10000">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5>Delete the {{selectedRegionName}} ?</h5>
      <p>Before deleting this company, please ensure that all devices associated with it are either removed or transferred to another company.</p>
      <p>Please ensure that the hierarchical relationship is removed before deleting this company.</p>
      <p>All configuration of company, member and authority will be removed after you confirm to delete.</p>
    </div>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="{{Confirm_button}}" (click)="deleteRegion()"></button>
      <button type="button" pButton (click)="deleteRegionDialog=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Save Admin -->
<p-dialog header="Confirm" [(visible)]="confirmSaveAdminDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5>This company will have no admin account. Are you sure you want to continue?</h5>
    </div>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton (click)="confirmSaveAdminDialog=false;adminSettingsDialog=true;" label="Back" class="p-button-secondary"></button>
      <button type="button" pButton label="Confirm" class="{{Confirm_button}}" (click)="saveAdminSetting(true)"></button>
    </div>
  </ng-template>
</p-dialog>


<!-- 2025-07-31 kyrie 手動Activate MSP功能移除 -->
<!-- <p-dialog header="Activate Company Plan" [(visible)]="activateCompanyPlanConfirmDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog distributeDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;">Plan Time will start counting after you click Confirm</p>
    <ul class="alert alert-danger show">
      <li>
        <span class="title">Plan : </span>
        <span>{{(companyPlanConfirm.IsMsp) ? 'Yes' : 'No'}}</span>
      </li>
      <li>
        <span class="title">Device Limit : </span>
        <span>{{(companyPlanConfirm.MspDeviceLimit) ? companyPlanConfirm.MspDeviceLimit : 'Unlimited'}}</span>
      </li>
      <li>
        <span class="title">Plan Type :</span>
        <span>{{companyPlanConfirm.MspPlanName}}</span>
      </li>
      <li>
        <span class="title">Plan Time :</span>
        <span *ngIf="companyPlanConfirm.MspPlanTime === 365">1 Year</span>
        <span *ngIf="companyPlanConfirm.MspPlanTime === 730">2 Year</span>
        <span *ngIf="companyPlanConfirm.MspPlanTime === 1095">3 Year</span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="activateCompanyPlan(companyPlanConfirm.Id);activateCompanyPlanConfirmDialog=false;"></button>
      <button type="button" pButton (click)="activateCompanyPlanConfirmDialog=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog> -->

<!-- Company Hierarchy Dialog  -->
<p-dialog header="{{hierarchydialogInput.UpdateType}}" [(visible)]="hierarchyDialog" [modal]="true" [style]="{'width': '450px', 'min-width': '200px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label>Company</label>
      <div class="select">
        <p-select [options]="CompanyOptions$ | async" [(ngModel)]="AddHierarchyParams.companySource" [style]="{'width':'100%'}" [disabled]="true"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label>Subsidiary Company</label>
      <div class="select">
        <p-select [options]="NonParentRegion" [(ngModel)]="AddHierarchyParams.childCompany" [style]="{'width':'100%'}" appendTo="body"></p-select>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveHierarchy();" label="Save" [disabled]="AddHierarchyParams.companySource <= 0 || AddHierarchyParams.childCompany <= 0"
            class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="hierarchyDialog=false;" label="Cancel" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="Confirm" [(visible)]="displayHierarchyConfirmDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="{{Confirm_button}}" (click)="deleteFromHierarchy()"></button>
      <button type="button" pButton (click)="displayHierarchyConfirmDialog=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Transfer NPM  -->
<p-dialog header="Transfer NPM" [(visible)]="dialogVisibility.transfer" [modal]="true" [style]="{'width': '450px', 'min-width': '200px'}" [baseZIndex]="10000" class="ConfirmDialog distributeDialog inherit">
  <div class="dialog-content">
    <div class="form-group">
      <label>Enter the number of NPM</label>
      <div class="select">
        <p-inputNumber [showButtons]="true" [min]="0" [step]="1" [(ngModel)]="transferDialogInput.quantity" (onChange)="disabledTransferConfirm()"
        [ngClass]="{'error-border': transferDialogInput.quantity > transferDialogInput.sourceNpm}"></p-inputNumber>
      </div>
      <p-message severity="error" text="{{'Insufficient NPM' | translate}}" *ngIf="transferDialogInput.quantity > transferDialogInput.sourceNpm || (transferDialogInput.sourceNpm - unActiveCompanyNPM - transferDialogInput.quantity < 0)"></p-message>
    </div>
    <div class="row transfer">
      <div class="col-md">
        <div class="form-group">
          <label>Transfer from </label>
          <div class="select">
            <p-select [options]="CompanySourceOptions" [(ngModel)]="transferDialogInput.source" [style]="{'width':'100%'}" disabled></p-select>
          </div>
        </div>
      </div>
      <div>
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </div>
      <div class="col-md">
        <div class="form-group">
          <label>Transfer to </label>
          <div class="select">
            <p-select [options]="CompanyTargetOptions" [(ngModel)]="transferDialogInput.target" [style]="{'width':'100%'}" (onChange)="disabledTransferConfirm();getCustomerNPM();"></p-select>
          </div>
        </div>
      </div>
    </div>

    <ul class="alert alert-warning long">
      <li style="flex-wrap: nowrap;">
        <div class="flex">
          <strong title="{{ getCompanyLabelById(transferDialogInput.source) }}">{{ getCompanyLabelById(transferDialogInput.source) }}</strong>
          <span>after transfer</span>
        </div>
        <span class="title right">{{ getSourceAfterTransfer() }}</span>
      </li>
      <li style="flex-wrap: nowrap;">
        <div class="flex">
          <strong title="{{ getCompanyLabelById(transferDialogInput.target) ? getCompanyLabelById(transferDialogInput.target) : '-' }}">
            {{ getCompanyLabelById(transferDialogInput.target) ? getCompanyLabelById(transferDialogInput.target) : '-' }}
          </strong>
          <span>after transfer</span></div>
        <span class="title right">{{ getTargetAfterTransfer() }}</span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="Confirm" class="{{Confirm_button}}" [disabled]="disabledTransferConfirmButton" (click)="confirmTransfer();"></button>
    <button type="button" pButton (click)="dialogVisibility.transfer=false;" label="Cancel" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Add/Edit Customer  -->
<p-dialog header="{{addCustomerDialogInput.UpdateType}}" [visible]="dialogVisibility.addCustomer || dialogVisibility.editCustomer" (onHide)="dialogVisibility.addCustomer = false; dialogVisibility.editCustomer = false" [modal]="true" [style]="{'width': '550px', 'min-width': '200px'}" [baseZIndex]="10000" class="ConfirmDialog distributeDialog" [closable]="false">
  <p-steps [(activeIndex)]="addCustomerStepIndex" [readonly]="true"></p-steps>
  <section *ngIf="addCustomerStepIndex === 1">
    <div class="dialog-content">
      <div class="form-group">
        <label>Company Name <span class="alert-danger">*</span></label>
        <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="addCustomerDialogInput.name" [disabled]="dialogVisibility.editCustomer && addCustomerDialogInput.status !== PROStatusIndex.Created">
      </div>
      <div class="form-group">
        <label>Transfer account to PPC PRO <span class="alert-danger">*</span></label>
        <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="addCustomerDialogInput.ownerAccount" (ngModelChange)="customerAccountOnChange()"
        [disabled]="dialogVisibility.editCustomer && addCustomerDialogInput.status !== PROStatusIndex.Created">
        <p-message severity="error" text="{{transferAccountErrorMessage}}" *ngIf="transferAccountError"></p-message>
        <div *ngIf="checkTransferAccountFail">
          <div [ngSwitch]="checkTransferAccountResult">
            <p-message severity="error" text="{{'No Account Found'}}" *ngSwitchCase="1"></p-message>
            <p-message severity="error" text="{{'This account has been upgraded to PPC PRO'}}" *ngSwitchCase="2"></p-message>
            <p-message severity="error" text="{{'This account does not belong to this region'}}" *ngSwitchCase="3"></p-message>
          </div>
        </div>
      </div>
      <div class="form-group type">
        <label>Customer's NPM Usage</label>
      </div>
      <div class="form-group type">
        <div class="col-list" style="margin-bottom: 4px">
          <p-radioButton name="addCustomerNpmType" value="0" inputId="addCustomerNpmType0" [(ngModel)]="addCustomerDialogInput.type"></p-radioButton><label for="addCustomerNpmType0">{{'Deduct from your NPM bank' | translate}}</label>
        </div>
        <div class="col-list">
          <p-radioButton name="addCustomerNpmType" value="1" inputId="addCustomerNpmType1" [(ngModel)]="addCustomerDialogInput.type"></p-radioButton><label for="addCustomerNpmType1">{{'Deduct from the customers NPM bank' | translate}}</label>
        </div>
      </div>
      <div class="form-group" *ngIf="addCustomerDialogInput.type === '1' && dialogVisibility.addCustomer">
        <label>How many NPM would you like to transfer</label>
        <div class="select">
          <p-inputNumber [showButtons]="true" [min]="0" [step]="1" [(ngModel)]="addCustomerDialogInput.quantity" [ngClass]="{'error-border': hasQuantityError()}"></p-inputNumber>
          <p-message severity="error" text="{{'Insufficient NPM' | translate}}" *ngIf="hasQuantityError()"></p-message>
        </div>
        <div class="alert alert-warning">
          <ul class="none">
            <li translate>The transfer will be completed only after the customer confirms.</li>
            <li translate>Once an invitation is sent to a Customer, this NPM quota will be allocated and cannot be transferred to another Customer.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="addCustomerStepIndex === 2">
    <div class="dialog-content">
      <ul class="alert alert-warning">
        <li>
          <span class="title">Company Name:</span>
          <span>{{addCustomerDialogInput.name}}</span>
        </li>
        <li>
          <span class="title">Transfer account to PPC PRO:</span>
          <span>{{addCustomerDialogInput.ownerAccount}}</span>
        </li>
        <li>
          <span class="title">Customer's NPM Usage:</span>
          <span>{{ addCustomerDialogInput.type === '0' ? 'Deduct from your NPM bank' : 'Deduct from the customers NPM bank' }}</span>
        </li>
        <li *ngIf="addCustomerDialogInput.type === '1'">
          <span class="title">Transfered NPM:</span>
          <span>{{addCustomerDialogInput.quantity}} NPM</span>
        </li>
      </ul>
    </div>
  </section>
  <section *ngIf="addCustomerStepIndex === 3" class="mail flex">
    <div class="icon">
      <span class="fa-stack fa-lg">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
      </span>
    </div>
    <div class="content-info">
      <h5 translate>Add Success</h5>
      <p translate>Please click the send icon to send the PPC PRO upgrade invitation to the customer. Once they confirm, we will proceed with completing the upgrade process.</p>
    </div>
  </section>
  <ng-template #footer>
    <section *ngIf="addCustomerStepIndex === 1">
      <button type="button" pButton (click)="checkTransferAccount();" label="{{'Save' | translate}}" class="ui-button-danger"
      [disabled]="disabledAddCustomerSave()" *ngIf="dialogVisibility.addCustomer"></button>
      <button type="button" pButton (click)="saveCustomer();" label="{{'Save' | translate}}" class="ui-button-danger"
      [disabled]="disabledEditCustomerSave()" *ngIf="dialogVisibility.editCustomer"></button>
      <button type="button" pButton (click)="dialogVisibility.addCustomer=false;dialogVisibility.editCustomer=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="addCustomerStepIndex === 2">
      <button type="button" pButton (click)="saveCustomer();" label="{{'Confirm' | translate}}" class="ui-button-danger"></button>
      <button type="button" pButton (click)="addCustomerStep(1);" label="{{'Previous' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="addCustomerStepIndex === 3">
      <button type="button" pButton (click)="dialogVisibility.addCustomer=false;" label="{{'Got it' | translate}}" class="ui-button-danger"></button>
    </section>
  </ng-template>
</p-dialog>

<!-- Delete Customer Warning -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogVisibility.deleteWarningCustomer" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <section *ngIf="deleteWarningCustomerStepIndex === 1">
    <div class="dialog-content align-items-top">
      <div class="icon">
        <i class="fa fa-exclamation-circle warning"></i>
      </div>
      <div class="content-info">
        <h5>The customer's NPM bank balance is currently negative.</h5>
        <p>Please transfer the NPM to bring the balance back to zero before remove it.</p>
      </div>
    </div>
  </section>
  <section *ngIf="deleteWarningCustomerStepIndex === 2">
    <div class="dialog-content align-items-top">
      <div class="icon">
        <i class="fa fa-exclamation-circle warning"></i>
      </div>
      <div class="content-info">
        <h5>During the delection process, the PPC PRO device will be transferred to the selected account manager.</h5>
        <p>Please inform the customer to assign a member as the account manager to proceed with the deletion.</p>
      </div>
    </div>
  </section>
  <ng-template #footer>
    <button type="button" pButton label="{{'OK' | translate}}" (click)="dialogVisibility.deleteWarningCustomer=false" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Delete Customer Confirm -->
<p-dialog header="Confirm" [(visible)]="dialogVisibility.deleteCustomer" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog distributeDialog inherit" [baseZIndex]="10000">
  <p-steps [(activeIndex)]="deleteCustomerStepIndex" [readonly]="true"></p-steps>
  <section *ngIf="deleteCustomerStepIndex === 1">
    <div class="dialog-content">
      <div class="form-group">
        <label>Are you sure to Delete this account to your customer list?</label>
        <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="deleteCustomerDialogInput.name" [disabled]="true">
      </div>
      <div class="form-group">
        <label>Transfer the device to</label>
        <div class="select">
          <!-- <p-select [options]="" [(ngModel)]="deleteCustomerDialogInput.account" [style]="{'width':'100%'}"></p-select> -->
          <p-select [options]="CustomerManagerOptions" [(ngModel)]="deleteCustomerDialogInput.Id"></p-select>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="deleteCustomerStepIndex === 2">
    <ul class="alert alert-warning">
      <li style="flex-wrap: nowrap; flex-direction: column; padding-bottom: 8px;">
        <span><strong>Please check the customer you would like to remove :</strong></span>
        <span>{{deleteCustomerDialogInput.name}}</span>
      </li>
      <li style="flex-wrap: nowrap; flex-direction: column;">
        <span><strong>The deivce will transefer to</strong></span>
        <span>{{this.deleteCustomerDialogInput.TargetAccount}}</span>
      </li>
    </ul>
  </section>
  <ng-template #footer>
    <section *ngIf="deleteCustomerStepIndex === 1">
      <button type="button" pButton (click)="deleteCustomerStepIndex=2" label="{{'Save' | translate}}" class="ui-button-danger"
      [disabled]="deleteCustomerDialogInput.name === null"></button>
      <button type="button" pButton (click)="dialogVisibility.deleteCustomer=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="deleteCustomerStepIndex === 2">
      <button type="button" pButton label="Confirm" class="{{Confirm_button}}" (click)="deleteCustomer()"></button>
      <button type="button" pButton (click)="dialogVisibility.deleteCustomer=false" label="Cancel" class="p-button-secondary"></button>
    </section>
  </ng-template>
</p-dialog>

<!-- Pay by Credit Card  -->
<p-dialog header="Pay" class="accountSetting" [(visible)]="dialogVisibility.PayByCard" [modal]="true" [style]="{'width': '450px', 'min-width': '230px'}" [baseZIndex]="10000"
          [blockScroll]="true" [ngClass]="{'inherit': inheritDialog }">
  <p-tabs class="settings_tabView" [tabindex]="PayByCardDialogInput.defaultTab" (valueChange)="onPayByCardTabChange($event)" value="0">
    <p-tablist>
        <p-tab value="0">{{'One-time purchase' | translate}}</p-tab>
        <p-tab value="1">{{'Monthly Direct Deduction' | translate}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="dialog-content">
          <div class="form-group type">
            <div class="col-list gap-1" style="margin-bottom: 4px">
              <p-radioButton name="payByCardType" value="0" inputId="payByCardType0" [(ngModel)]="PayByCardDialogInput.type" (ngModelChange)="onPROPaymentSettingChange(true)"></p-radioButton>
              <label for="payByCardType0" translate>Minimum Payment Due</label>
              <span style="padding-left:4px"> ({{ accountActivityNodeBank >= 0 ? 0 : (accountActivityNodeBank * -1) }} NPM)</span>
            </div>
            <div class="col-list gap-1">
              <p-radioButton name="payByCardType" value="1" inputId="payByCardType1" [(ngModel)]="PayByCardDialogInput.type" (ngModelChange)="onPROPaymentSettingChange(true)"></p-radioButton>
              <label for="payByCardType1" translate>Enter the number of NPM</label>
              <span style="padding-left:4px"> (can be prepaid)</span>
            </div>
          </div>
          <div class="form-group" *ngIf="PayByCardDialogInput.type === '1'">
            <div class="select">
              <p-inputNumber [showButtons]="true" [min]="0" [step]="1" [(ngModel)]="PayByCardDialogInput.quantity" (ngModelChange)="onPROPaymentSettingChange(false)"
              [ngClass]="{'error-border': this.PROPaymentSetting.PaymentNPMBank > 0 && PayByCardDialogInput.quantity < PROPaymentSetting.PaymentNPMBank}"></p-inputNumber>
            </div>
            <p-message severity="error" [text]="('Can not be less than' | translate) + ' ' + PROPaymentSetting.PaymentNPMBank + ' NPM'" *ngIf="this.PROPaymentSetting.PaymentNPMBank > 0 && PayByCardDialogInput.quantity < PROPaymentSetting.PaymentNPMBank"></p-message>
          </div>
          <ul class="alert alert-warning">
            <li>
              <span class="title">Unit Price (USD/NPM): </span>
              <span>${{paymentUnitPrice}}</span>
            </li>
            <li>
              <span class="title">Total Amount (USD) : </span>
              <span>${{PROPaymentSetting.TotalAmount | number:'1.2-2'}}</span>
            </li>
            <li>
              <span class="title">NPM Bank after Payment: </span>
              <span>{{PROPaymentSetting.AfterPayment}}</span>
            </li>
          </ul>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="dialog-content" *ngIf="PROPaymentSetting.UserChargeType !== ChargeType.Monthly">
          <p style="margin-bottom: 8px">To enable monthly payments, please authorize your credit card by click the button below to set up your payment information.</p>
          <p style="margin-bottom: 8px">The amount deducted each month will be based on your maximum device usage during that period, with a minimum order quantity (MOQ) of 20.</p>
          <p>Please note that PowerPanel Cloud will not record your payment information. </p>
        </div>
        <div class="dialog-content" *ngIf="PROPaymentSetting.UserChargeType === ChargeType.Monthly">
          <p style="margin-bottom: 8px">Your credit card has already been authorized for monthly payment.</p>
          <ul class="alert alert-warning">
            <li>
              <span class="title">Next payment date: </span>
              <span>{{predictedNPMUsage.SettlementDate}}</span>
            </li>
          </ul>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template #footer>
    <div class="flex">
      <div #paypalContainer *ngIf="PayByCardDialogInput.defaultTab === '0'" class="paypal"></div>
      <!-- <button *ngIf="PayByCardDialogInput.defaultTab === 0 && display_paypal_btn" [disabled]="true">PayPal</button> -->
      <button type="button" pButton icon="fa fa-paypal" label="Monthly Deduction Settings" *ngIf="PayByCardDialogInput.defaultTab === '1' && PROPaymentSetting.UserChargeType !== ChargeType.Monthly" (click)="addPaymentAgreement()"></button>
      <button type="button" pButton icon="fa fa-paypal" label="Change Settings" *ngIf="PayByCardDialogInput.defaultTab === '1' && PROPaymentSetting.UserChargeType === ChargeType.Monthly" (click)="addPaymentAgreement()" class="p-button-primary"></button>
      <button type="button" pButton (click)="dialogVisibility.PayByCard=false;" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Payment Result -->
<p-dialog header="{{'Pay' | translate}}" [(visible)]="dialogVisibility.PayByCardResult" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content" [ngSwitch]="PayByCardResult">
    <div class="icon">
      <i class="fa fa-check-circle normal" *ngSwitchCase="0"></i>
      <i class="fa fa-times-circle critical" *ngSwitchCase="1"></i>
    </div>
    <div class="content-info">
      <h5 *ngSwitchCase="0">Payment Completed</h5>
      <h5 *ngSwitchCase="1">Payment not Completed</h5>
      <p *ngSwitchCase="0">Thank you for your purchase</p>
      <p *ngSwitchCase="1">Your payment can not be completed, Please try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'OK' | translate}}" (click)="dialogVisibility.PayByCardResult=false" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-toast [style]="{marginTop: '70px'}"></p-toast>

<app-dialog (connectEvt)="controlCompanyMember($event);saveCompanyMember($event);"></app-dialog>
